
/* MIONA Gallery Arrows: Desktop hover, hide at start/end */
(function() {
  function updateArrows(gallery) {
    var carousel = gallery.querySelector('scroll-carousel');
    if (!carousel) return;
    var prev = gallery.querySelector('.miona-gallery-arrow--prev');
    var next = gallery.querySelector('.miona-gallery-arrow--next');
    if (!prev || !next) return;

    var idx = carousel.selectedIndex;
    var total = carousel.cells ? carousel.cells.length : 0;

    if (idx <= 0) prev.classList.add('is-hidden');
    else prev.classList.remove('is-hidden');

    if (idx >= total - 1) next.classList.add('is-hidden');
    else next.classList.remove('is-hidden');
  }

  function init() {
    document.querySelectorAll('product-gallery').forEach(function(gallery) {
      var carousel = gallery.querySelector('scroll-carousel');
      if (!carousel) return;

      // Click handlers
      var prev = gallery.querySelector('.miona-gallery-arrow--prev');
      var next = gallery.querySelector('.miona-gallery-arrow--next');

      if (prev) {
        prev.addEventListener('click', function(e) {
          e.preventDefault();
          carousel.previous();
          setTimeout(function() { updateArrows(gallery); }, 400);
        });
      }
      if (next) {
        next.addEventListener('click', function(e) {
          e.preventDefault();
          carousel.next();
          setTimeout(function() { updateArrows(gallery); }, 400);
        });
      }

      // Listen for scroll to update state
      carousel.addEventListener('scroll', function() {
        clearTimeout(carousel._arrowTimer);
        carousel._arrowTimer = setTimeout(function() { updateArrows(gallery); }, 150);
      }, {passive: true});

      // Initial state
      updateArrows(gallery);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(init, 300); });
  } else {
    setTimeout(init, 300);
  }

  // Also update when thumbnails are clicked
  document.addEventListener('click', function(e) {
    if (e.target.closest('product-gallery-navigation')) {
      document.querySelectorAll('product-gallery').forEach(function(g) {
        setTimeout(function() { updateArrows(g); }, 400);
      });
    }
  });
})();
